import { ArrowSmDownIcon, ArrowSmUpIcon } from '@heroicons/react/solid';
import {
  BadgeCheckIcon,
  CursorClickIcon,
  HomeIcon,
  MailOpenIcon,
  StarIcon,
  UsersIcon,
} from '@heroicons/react/outline';
import { Link } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';

const stats = [
  {
    id: 1,
    name: 'Total Listings',
    stat: '00',
    icon: HomeIcon,
    change: '122',
    changeType: 'increase',
  },
  {
    id: 2,
    name: 'Total Active Listings',
    stat: '00',
    icon: BadgeCheckIcon,
    change: '5.4%',
    changeType: 'increase',
  },
];

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

export default function Stats() {
  const { data, loading, error } = useQuery(GET_ACCOUNT_STATS);

  if (!data || loading || error) return null;

  return (
    <div>
      {/* <h3 className="text-lg leading-6 font-medium text-gray-900">
        Last 30 days
      </h3> */}

      <dl className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {/* {stats.map((item) => (
        ))} */}
        <div className="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
          <dt>
            <div className="absolute bg-primary-light rounded-md p-3">
              <HomeIcon className="h-6 w-6 text-white" aria-hidden="true" />
            </div>
            <p className="ml-16 text-sm font-medium text-gray-500 truncate">
              Total Listings
            </p>
          </dt>
          <dd className="ml-16 pb-6 flex items-baseline sm:pb-7">
            <p className="text-2xl font-semibold text-gray-900">
              {data.accountStats.totalListings}
            </p>
            {/* <p
                className={classNames(
                  item.changeType === 'increase'
                    ? 'text-green-600'
                    : 'text-red-600',
                  'ml-2 flex items-baseline text-sm font-semibold'
                )}
              >
                {item.changeType === 'increase' ? (
                  <ArrowSmUpIcon
                    className="self-center flex-shrink-0 h-5 w-5 text-green-500"
                    aria-hidden="true"
                  />
                ) : (
                  <ArrowSmDownIcon
                    className="self-center flex-shrink-0 h-5 w-5 text-red-500"
                    aria-hidden="true"
                  />
                )}

                <span className="sr-only">
                  {item.changeType === 'increase' ? 'Increased' : 'Decreased'}{' '}
                  by
                </span>
                {item.change}
              </p> */}
            <div className="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
              <div className="text-sm">
                <Link to="/listings">
                  <a
                    href="/listings"
                    className="font-medium text-primary hover:text-primary-light"
                  >
                    {' '}
                    View all
                  </a>
                </Link>
              </div>
            </div>
          </dd>
        </div>
        <div className="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
          <dt>
            <div className="absolute bg-primary-light rounded-md p-3">
              <BadgeCheckIcon
                className="h-6 w-6 text-white"
                aria-hidden="true"
              />
            </div>
            <p className="ml-16 text-sm font-medium text-gray-500 truncate">
              Total Active Listings
            </p>
          </dt>
          <dd className="ml-16 pb-6 flex items-baseline sm:pb-7">
            <p className="text-2xl font-semibold text-gray-900">
              {data.accountStats.totalActiveListings}
            </p>
            {/* <p
                className={classNames(
                  item.changeType === 'increase'
                    ? 'text-green-600'
                    : 'text-red-600',
                  'ml-2 flex items-baseline text-sm font-semibold'
                )}
              >
                {item.changeType === 'increase' ? (
                  <ArrowSmUpIcon
                    className="self-center flex-shrink-0 h-5 w-5 text-green-500"
                    aria-hidden="true"
                  />
                ) : (
                  <ArrowSmDownIcon
                    className="self-center flex-shrink-0 h-5 w-5 text-red-500"
                    aria-hidden="true"
                  />
                )}

                <span className="sr-only">
                  {item.changeType === 'increase' ? 'Increased' : 'Decreased'}{' '}
                  by
                </span>
                {item.change}
              </p> */}
            <div className="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
              <div className="text-sm">
                <Link to="/listings">
                  <a
                    href="/listings"
                    className="font-medium text-primary hover:text-primary-light"
                  >
                    {' '}
                    View all
                  </a>
                </Link>
              </div>
            </div>
          </dd>
        </div>
        <div className="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
          <dt>
            <div className="absolute bg-primary-light rounded-md p-3">
              <StarIcon className="h-6 w-6 text-white" aria-hidden="true" />
            </div>
            <p className="ml-16 text-sm font-medium text-gray-500 truncate">
              Current Subscription
            </p>
          </dt>
          <dd className="ml-16 pb-6 flex items-baseline sm:pb-7">
            <p className="text-lg font-semibold text-gray-900">
              {data.accountStats.subscriptionName}
            </p>
            {/* <p
                className={classNames(
                  item.changeType === 'increase'
                    ? 'text-green-600'
                    : 'text-red-600',
                  'ml-2 flex items-baseline text-sm font-semibold'
                )}
              >
                {item.changeType === 'increase' ? (
                  <ArrowSmUpIcon
                    className="self-center flex-shrink-0 h-5 w-5 text-green-500"
                    aria-hidden="true"
                  />
                ) : (
                  <ArrowSmDownIcon
                    className="self-center flex-shrink-0 h-5 w-5 text-red-500"
                    aria-hidden="true"
                  />
                )}

                <span className="sr-only">
                  {item.changeType === 'increase' ? 'Increased' : 'Decreased'}{' '}
                  by
                </span>
                {item.change}
              </p> */}
            <div className="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
              <div className="text-sm">
                <Link to="/account/billing">
                  <a className="font-medium text-primary hover:text-primary-light">
                    {' '}
                    View details
                  </a>
                </Link>
              </div>
            </div>
          </dd>
        </div>
      </dl>
    </div>
  );
}

const GET_ACCOUNT_STATS = gql`
  query OverviewStats_AccountStats {
    accountStats {
      totalListings
      totalActiveListings
      subscribed
      subscriptionName
    }
  }
`;
